import { use } from 'react'
import {
  FeatureFlagsContext,
  type FeatureFlagsContextType,
} from '@/features/shared/context/FeatureFlagsContext/FeatureFlagsContext'

export const useFeatureFlags = (): FeatureFlagsContextType => {
  const context = use(FeatureFlagsContext)
  if (!context) {
    throw new Error('useFeatureFlagsContext must be used within a FeatureFlagsProvider')
  }
  return context
}
